import React from "react";
import { Row } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useMultipleUserSubmissions } from "../../api/APIClient";
import { SmallTable } from "./SmallTable";
import { DifficultyTable } from "./DifficultyTable";
import { FilterParams, ProblemList } from "./ProblemList";

interface Props {
  readonly userId: string;
}

export const ListPage: React.FC<Props> = (props) => {
  const location = useLocation();
  const history = useHistory();

  const submissions = useMultipleUserSubmissions([props.userId]).data ?? [];

  const setPointRangeFilter = (from: number, to: number): void => {
    const params = new URLSearchParams(location.search);
    params.set(FilterParams.FromPoint, from.toString());
    params.set(FilterParams.ToPoint, to.toString());
    history.push({ ...location, search: params.toString() });
  };
  const setDifficultyFilter = (from: number, to: number): void => {
    const params = new URLSearchParams(location.search);
    params.set(FilterParams.FromDifficulty, from.toString());
    params.set(FilterParams.ToDifficulty, to.toString());
    history.push({ ...location, search: params.toString() });
  };

  return (
    <div>
      <Row className="my-2 border-bottom">
        <h1>Point Status</h1>
      </Row>
      <Row>
        <SmallTable
          submissions={submissions}
          setFilterFunc={setPointRangeFilter}
        />
      </Row>

      <Row className="my-2 border-bottom">
        <h1>Difficulty Status</h1>
      </Row>
      <Row>
        <DifficultyTable
          submissions={submissions}
          setFilterFunc={setDifficultyFilter}
        />
      </Row>

      <ProblemList userId={props.userId} submissions={submissions} />
    </div>
  );
};
